import { render, staticRenderFns } from "./ResultadoToggle.vue?vue&type=template&id=c31a5234&scoped=true"
import script from "./ResultadoToggle.vue?vue&type=script&lang=js"
export * from "./ResultadoToggle.vue?vue&type=script&lang=js"
import style0 from "./ResultadoToggle.vue?vue&type=style&index=0&id=c31a5234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31a5234",
  null
  
)

export default component.exports